var search_filters = document.querySelectorAll('.search-filter-container');
var search_filter_heading = document.querySelector('.filter-heading a');
var single_select_filter_items = document.querySelectorAll('.search-filter-dropdown.single-select li a');
var multi_select_filter_items = document.querySelectorAll('.search-filter-dropdown.multi-select li a');
var expand_all_filter_items = document.querySelectorAll('.search-filter-dropdown .expandable-trigger a');
var collapse_all_filter_items = document.querySelectorAll('.search-filter-dropdown .expandable-collapse a');


var filter_form_select = document.querySelectorAll('.filter-form select')[0];
if(filter_form_select) {
	$(filter_form_select).on('focusin',function() {
		document.addEventListener('keyup', function(e) {
	        if (e.key === "Escape") {
				var thisParentMenuUL = $(filter_form_select).closest('ul.filter-form');
				var thisParentMenuItem = $(thisParentMenuUL).prev('a');
				$(thisParentMenuItem).attr('aria-expanded','false').focus();
				$(thisParentMenuUL).css('display','none');
			}
		});			
	});
}
  
if (search_filter_heading) {
  search_filter_heading.addEventListener('click', function(event) {
    document.querySelector('.search-filter-wrap').classList.toggle('closed');
	var expanded = document.querySelector('.filter-heading a').getAttribute('aria-expanded');
	if(expanded == 'true') {
		expanded = 'false';
	} else {
		expanded = 'true';
	}
    document.querySelector('.filter-heading').classList.toggle('closed');
	document.querySelector('.filter-heading a').setAttribute('aria-expanded',expanded);
    event.preventDefault();
  });
}

if (single_select_filter_items) {
  for (var i = 0; i < single_select_filter_items.length; i++) {
	single_select_filter_items[i].addEventListener('click', function(event) {
		event.preventDefault();
		var thisEl = this;
		toggleAriaLabel(thisEl);
		[].forEach.call(single_select_filter_items, function(el) {
		    el.classList.remove('active');
		    el.parentNode.classList.remove('active');
		});
		thisEl.classList.toggle('active');
		thisEl.parentNode.classList.toggle('active');
	}, false);
  }
}

if (multi_select_filter_items) {
  for (var i = 0; i < multi_select_filter_items.length; i++) {
	multi_select_filter_items[i].addEventListener('click', function(event) {
		event.preventDefault();
		var thisEl = this;
		toggleAriaLabel(thisEl);
		thisEl.classList.toggle('active');
		thisEl.parentNode.classList.toggle('active');
	}, false);
  }
}

function toggleAriaLabel(el) {
	var active = el.getAttribute('aria-label');
	var thistext = el.innerHTML;
	if((!active) || (active == '')) {
		active = 'Selected filter: ' + thistext;
	} else {
		active = '';
	}
    el.setAttribute('aria-label',active);
} 

if (expand_all_filter_items) {
  for (var i = 0; i < expand_all_filter_items.length; i++) {
	expand_all_filter_items[i].addEventListener('click', function(event) {
		event.preventDefault();
		this.classList.toggle('hidden');
		var thisParentLi = this.parentNode;
		var thisParentUl = thisParentLi.parentNode;
		thisParentLi.classList.toggle('hidden');
		thisParentUl.querySelector('.expandable-collapse').classList.toggle('hidden');
		var theseExpandableItems = thisParentUl.querySelectorAll('.expandable');
	    for (var x = 0; x < theseExpandableItems.length; x++) {
			theseExpandableItems[x].classList.toggle('hidden');
		}
	}, false);
  }
}

if (collapse_all_filter_items) {
  for (var i = 0; i < collapse_all_filter_items.length; i++) {
	collapse_all_filter_items[i].addEventListener('click', function(event) {
		event.preventDefault();
		this.classList.toggle('hidden');
		var thisParentLi = this.parentNode;
		var thisParentUl = thisParentLi.parentNode;
		thisParentLi.classList.toggle('hidden');
		thisParentUl.querySelector('.expandable-trigger').classList.toggle('hidden');
		var theseExpandableItems = thisParentUl.querySelectorAll('.expandable');
	    for (var x = 0; x < theseExpandableItems.length; x++) {
			theseExpandableItems[x].classList.toggle('hidden');
		}
	}, false);
  }
}